import { Dispatch, SetStateAction } from 'react'
import { useHistory } from 'react-router-dom'

// locals
import FavoritesService from 'service/FavoritesService'
import { IFavoriteLocations, IFloor } from 'types/FavoritesType'
import { RoutingType } from 'types/FloorType'
import { PlanTabs } from 'types/PlanTabs'

export default function useListActions(setList: Dispatch<SetStateAction<[] | IFavoriteLocations[]>>) {
  const history = useHistory()

  const handleRemoveFavorite = (floorId: number) => () => {
    FavoritesService.removeFavoriteLocation(floorId)
      .then((r) => setList((prev) => prev.filter((pr) => pr.floor.id !== floorId)))
      .catch((err) => console.log(err))
  }

  const handleSetReservation = (floor: IFloor) => () => {
    const reservationMeta = {
      startDate: new Date(),
      endDate: new Date(),
      isAbroad: { name: 'countries.turkey', isAbroad: false },
      planTab: floor?.isShared ? PlanTabs.COMMON : PlanTabs.OFFICE,
      isNew: true,
      routingType: RoutingType.HOME_PAGE,
      selectedFloor: {
        ...floor,
        isFavorite: true,
        _fullLocation: `${floor?.locationName}, ${floor?.districtName}, ${floor?.blockName}, ${floor?.name}`,
        _floorName: floor?.name,
        _id: floor?.id,
      },
    }

    history.push({ pathname: '/reservation', state: { response: reservationMeta } })
  }

  return { handleRemoveFavorite, handleSetReservation }
}
